import { render, staticRenderFns } from "./PrizesPayments.vue?vue&type=template&id=5157587a&scoped=true&"
import script from "./PrizesPayments.js?vue&type=script&lang=js&"
export * from "./PrizesPayments.js?vue&type=script&lang=js&"
import style0 from "./PrizesPayments.scss?vue&type=style&index=0&id=5157587a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157587a",
  null
  
)

export default component.exports